/** Konstanta & helper kecil `voice-controller.ts` (sesi mode suara panel). */

/** Tunggu transkrip setelah delegasi dibuat (event delegasi tak memuat ucapan). */
export const TRANSCRIPT_WAIT_MS = 2000;
export const TRANSCRIPT_POLL_MS = 100;
/** Delegasi tak datang selama ini setelah ucapan user terakhir → klien menanyakan ke Claude sendiri (teks saja). */
export const DELEGATION_FALLBACK_MS = 6000;
/**
 * Hening selama ini setelah ucapan terakhir → chip berubah "Memproses…".
 *
 * Dipasang tertunda, BUKAN saat `scheduleFallback()` menyala: di `onEvent`,
 * `setStatus("listening")` dipanggil tepat setelahnya dan akan menimpanya,
 * sehingga penanda tak pernah terlihat. Jeda ini juga menjaga chip tidak
 * berkedip saat pengguna bicara terbata — ia hanya muncul setelah jeda nyata.
 */
export const WAITING_HINT_MS = 1200;

/** Selama Jenna masih terdengar sampai selisih ini, fallback ditunda (ia sedang menjawab sendiri). */
export const FALLBACK_QUIET_MS = 1500;
/** Banyak potongan transkrip Jenna yang bentuknya dicatat per ucapan user (diagnosis spasi). */
export const OUTPUT_DELTA_SAMPLES = 10;
/** Tunggu `session.started` setelah data channel terbuka sebelum dianggap siap. */
export const STARTED_FALLBACK_MS = 3000;
/** RMS audio GPT-Live yang dianggap terdengar. */
export const REMOTE_AUDIBLE_RMS = 0.01;
/** Kembali "Siap bicara" setelah jawaban terkirim dan audio GPT-Live hening. */
export const PANEL_SETTLE = {
	minWaitMs: 1500,
	quietMs: 1200,
	maxWaitMs: 60_000,
	pollMs: 250,
};
export const MIC_OPTIONS = {
	deviceId: "",
	echoCancellation: true,
	noiseSuppression: true,
};

/** Tunda `ms` milidetik. */
export const sleep = (ms: number) =>
	new Promise<void>((r) => setTimeout(r, ms));

/** Angka dari field event GPT-Live, atau undefined. */
export const num = (v: unknown) => (typeof v === "number" ? v : undefined);

/** Galat pembatalan (`AbortController.abort()`). */
export const isAbort = (err: unknown) =>
	err instanceof DOMException && err.name === "AbortError";
